// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleOnInputChange(event) {

    this.onInputChange(this.identifier, event.target.value);

}

const DealerSearchInput = props =>
    <div className={props.style}>
        <FormattedMessage id={props.text}/>
        <input
            onChange={props::handleOnInputChange}
            type='text'
            value={props.value}
        />
    </div>;

DealerSearchInput.displayName = 'DealerSearchInput';
DealerSearchInput.propTypes = {
    identifier: PropTypes.string.isRequired,
    onInputChange: PropTypes.func.isRequired,
    style: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default DealerSearchInput;



// WEBPACK FOOTER //
// ./src/product/dealer-search/components/dealer-search-input.js